import { getTokens, storeTokens } from "./tokenStorage";
import { getCognitoConfig } from "./cognitoConfig";

const EXPIRY_BUFFER_S = 30;

export const isTokenExpired = (token) => {
  try {
    const payload = token.split(".")[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(atob(base64));
    const exp = typeof claims.exp === "number" ? claims.exp : 0;
    return Date.now() / 1000 >= exp - EXPIRY_BUFFER_S;
  } catch {
    return true;
  }
};

let inflightRefresh = null;

export const refreshCognitoTokens = () => {
  if (inflightRefresh) return inflightRefresh;
  inflightRefresh = doRefresh().finally(() => {
    inflightRefresh = null;
  });
  return inflightRefresh;
};

const doRefresh = async () => {
  const tokens = getTokens();
  if (!tokens?.refreshToken) return false;

  const { domain, clientId } = getCognitoConfig();

  const body = new URLSearchParams({
    grant_type: "refresh_token",
    client_id: clientId,
    refresh_token: tokens.refreshToken,
  });

  try {
    const response = await fetch(`${domain}/oauth2/token`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    if (!response.ok) return false;

    const data = await response.json();
    if (
      typeof data?.id_token !== "string" ||
      typeof data?.access_token !== "string"
    ) {
      return false;
    }

    storeTokens({
      idToken: data.id_token,
      accessToken: data.access_token,
      refreshToken: tokens.refreshToken,
    });
    return true;
  } catch {
    return false;
  }
};
